<template>
  <div>
    <LoadingBusy :loading="loading" :isAuthenticating="false" text="Loading, please wait...">
    </LoadingBusy>
    <p class="page-heading mb-2">
      Time remaining to confirm:
      <span class="red--text">
        {{ formattedTimerValue }}
      </span>
    </p>
    <BookingDetailsPanel />
    <p class="mt-6">
      Please arrive early to complete required forms. You may not check in more than
      {{earlyMinutesSetting}} minutes prior to your appointment.
    </p>
    <p>If you are more than {{lateMinutesSetting}} minutes late,
      your appointment may be cancelled.  I have or will have completed ELDT
      prior to this appointment.
    </p>
    <div style="width: 90%" class="text-center mx-auto">
      <v-row>
        <v-col cols="12" md="6">
          <v-btn class="ma-2" color="primary" @click="previousClick()"
            ><v-icon>mdi-arrow-left</v-icon>
            PREVIOUS
          </v-btn>
        </v-col>
        <v-col cols="12" md="6">
          <v-btn class="ma-2 text--uppercase" color="primary" @click="nextClick()">
            <v-icon>mdi-content-save-move</v-icon>
            CONFIRM
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-alert
        class="ma-2"
        type="error"
        :value="isError"
        dense
        outlined
        dismissible
        transition="scale-transition"
      >
        {{ errorMessage }}
      </v-alert>
    </div>
  </div>
</template>

<script>
import BookingDetailsPanel from '@/components/BookingDetailsPanel.vue';
import { mapGetters, mapActions } from 'vuex';
import LoadingBusy from '../components/LoadingBusy.vue';
import scApi from '../api/scApi';

export default {
  components: {
    BookingDetailsPanel,
    LoadingBusy,
  },
  data() {
    return {
      ConfirmTimer: '',
      ConfirmSeconds: '',
      loading: false,
      isError: false,
      errorMessage: '',
    };
  },
  computed: {
    ...mapGetters('userInfo', [
      'dLNumber',
      'firstName',
      'lastName',
      'dateOfBirth',
      'email',
      'phone',
      'testTypeId',
      'homePhone',
    ]),
    ...mapGetters('bookingDetails', [
      'slotId',
      'bookingDateTime',
      'bookingDuration',
      'siteId',
      'rescheduleBooking',
    ]),
    ...mapGetters(['responseID', 'textMsgCheckBox']),
    ...mapGetters(['earlyMinutes', 'lateMinutes']),
    earlyMinutesSetting() {
      return this.earlyMinutes !== 0
        ? this.earlyMinutes
        : 30;
    },
    lateMinutesSetting() {
      return this.lateMinutes !== 0
        ? this.lateMinutes * (-1)
        : 10;
    },
    formattedTimerValue() {
      const date = new Date(null);
      date.setSeconds(this.ConfirmSeconds);
      const result = date.toISOString().substr(14, 5);
      return result;
    },
  },
  methods: {
    ...mapActions('bookingDetails', {
      confirmationNumberAction: 'confirmationNumber',
    }),
    nextPage(page) {
      this.$emit('navigateTo', page);
    },
    previousClick() {
      this.stopTimer();
      console.log('Release Slot for Booking');
      if (this.slotId > 0) {
        this.releaseBookingSlot();
      }
      this.$emit('navigateTo', 'SelectLocation');
    },
    async nextClick() {
      this.stopTimer();
      console.log('Confirm appointment');
      console.log(this.siteId);
      console.log(this.textMsgCheckBox);
      console.log(this.bookingDateTime);
      console.log(this.bookingDuration);
      console.log(this.testTypeId);
      if (!this.rescheduleBooking) {
        console.log('NewBooking');
        this.loading = true;
        try {
          const response = await scApi.NewBooking(
            this.dLNumber,
            this.firstName,
            this.lastName,
            this.dateOfBirth,
            this.email,
            this.phone,
            this.testTypeId,
            this.bookingDateTime,
            this.bookingDuration,
            this.siteId,
            this.textMsgCheckBox,
            this.responseID,
          );
          console.log(response);
          if (response.ErrorMessage === null) {
            this.confirmationNumberAction({
              value: response.Booking.ConfirmationNumber,
            });
            this.$emit('navigateTo', 'ConfirmationPage');
          } else {
            console.log(response.ErrorMessage);
            this.isError = true;
            this.errorMessage = response.ErrorMessage;
          }
        } catch (error) {
          console.log(error);
          this.isError = true;
          this.errorMessage = error;
        } finally {
          console.log('Inside NewBooking finally');
          this.loading = false;
        }
      } else {
        console.log('RescheduleBooking');
        this.loading = true;
        try {
          const response = await scApi.RescheduleBooking(
            this.dLNumber,
            this.responseID,
            this.testTypeId,
            this.bookingDateTime,
            this.bookingDuration,
            this.firstName,
            this.lastName,
            this.dateOfBirth,
            this.email,
            this.homePhone,
            this.phone,
            this.textMsgCheckBox,
            this.siteId,
          );
          console.log(response);
          if (response.ErrorMessage === null) {
            this.confirmationNumberAction({
              value: response.Booking.ConfirmationNumber,
            });
            this.$emit('navigateTo', 'ConfirmationPage');
          } else {
            console.log(response.ErrorMessage);
            this.isError = true;
            this.errorMessage = response.ErrorMessage;
          }
        } catch (error) {
          console.log(error);
          this.isError = true;
          this.errorMessage = error;
        } finally {
          console.log('Inside RescheduleBooking finally');
          this.loading = false;
        }
      }
    },
    updateTimerValue() {
      this.ConfirmSeconds -= 1;
      if (this.ConfirmSeconds === 0) {
        console.log('Release slot for booking');
        if (this.slotId > 0) {
          this.releaseBookingSlot();
        }
        console.log('Rewind to select options');
        this.$emit('navigateTo', 'SelectLocation');
      }
    },
    stopTimer() {
      if (this.ConfirmTimer) {
        clearInterval(this.ConfirmTimer);
      }
    },
    async releaseBookingSlot() {
      try {
        this.loading = true;
        const response = await scApi.ReleaseBookingSlot(this.slotId, this.dLNumber);
        console.log(response);
      } catch (error) {
        console.log(error);
        this.isError = true;
        this.errorMessage = error;
      } finally {
        console.log('Inside releaseBookingSlot finally');
        this.loading = false;
      }
    },
  },
  created() {
    const method = this.updateTimerValue;
    this.ConfirmSeconds = 300;
    this.ConfirmTimer = setInterval(method, 1000);
  },
  beforeDestroy() {
    this.stopTimer();
  },
};
</script>

<style></style>
